import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import ModalPadraoForm from './ModalPadraoForm';
import TituloParcelaForm from './TituloParcelaForm';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import CtaCorrenteFrame from './CtaCorrenteFrame';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;

export const OPCOES_COMBO = [
  { key: 'E', label: 'Entrada' },
  { key: 'S', label: 'Saída' },
]

export const OPCOES_COMBO_PARC = [
  { key: 'A', label: 'ABERTO' },
  { key: 'P', label: 'PAGO' },
]

export default class TituloForm extends Component {
  state = {
    registro: {
      tit_idf: 0,
      tit_controle: 0,
      tit_numero: 0,
      tit_tipo: { key: 'S', label: 'Saída', },
      tit_data_emissao: moment().format('DD/MM/YYYY'),
      tit_descricao: '',
      tit_pessoa: { key: '0', label: '', },
      tit_valor: 0,
      tit_tipo_doc: { key: '0', label: '', },
      tit_cond_pagto: { key: '0', label: '', },
      tit_plano_conta: { key: '0', label: '', },
      tit_cta_corrente: { key: '0', label: '', },
      tit_idf_contrato: 0,
    },
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,

    formParcDisabled: true,
    activeKey: "dados",

    pessoasSelect: [],
    pessoasTipoSelect: [],
    planoCtasSelect: [],
    planoCtasTipoSelect: [],

    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

    registroParcela: {
      tparc_parcela: 0,
      tparc_data_parcela: '',
      tparc_tipo_doc: { key: '0', label: '', },
      tparc_conta_corrente: { key: '0', label: '', },
      tparc_valor: 0,
      tparc_situacao: { key: 'A', label: 'ABERTO', },
      tparc_obs: '',
      td_descricao: '',
      cc_descricao: '',
      situacao_parcela: '',
      pgto_vlr_desconto: 0,
      pgto_vlr_acrescimo: 0,
      pgto_vlr_pago: 0,
      pgto_vlr_restante: 0,
      pgto_data: '',
      pgto_cta_corrente: '',
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {

      this.setState({
        registro: this.props.registroSelecionado.dados,
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        visualizar: this.props.registroSelecionado.visualizar,
        tipoTela: this.props.registroSelecionado.tipoTela,
        tit_idf_contrato: this.props.registroSelecionado.tit_idf_contrato ? this.props.registroSelecionado.tit_idf_contrato : 0,
        editando: false,
        activeKey: "dados",
      }, () => {
        Promise.all([
          this.buscaPessoas(),
          this.buscaPlanoCtas(),
        ]).then(() => {
          this.montaTipo(this.props.registroSelecionado.dados.tit_tipo.key);
        });
      });

      if (this.props.registroSelecionado.dados.tit_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }

    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }


  buscaPessoas = async () => {
    this.setState({ pessoasSelect: [] });
    return await axios.get('/pessoas/lista')
      .then(response => {
        const { data } = response;
        const pessoasSelect = data.map(regList => {
          return {
            key: regList.pes_idf,
            label: regList.pes_nome + ' [' + regList.pes_codigo + '] ' + (regList.pes_cpf_cnpj !== '' ? ' [' + regList.pes_cpf_cnpj + '] ' : ''),
            cliente: regList.pes_cliente,
            fornec: regList.pes_fornecedor,
          }
        });
        this.setState({
          pessoasSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  buscaPlanoCtas = async () => {
    this.setState({ planoCtasSelect: [] });
    return await axios.get('/planoContas/lista')
      .then(response => {
        const { data } = response;
        const planoCtasSelect = data.map(regList => {
          return {
            key: regList.pc_idf,
            label: regList.pc_descricao + ' [' + regList.pc_conta + ']',
            tipo: regList.pc_tipo,
          }
        });
        this.setState({
          planoCtasSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }

  montaTipo = (tipo) => {
    let pessoasTipoSelect = [];
    for (var x in this.state.pessoasSelect) {
      if ((tipo === 'E') && (this.state.pessoasSelect[x].cliente)) {
        pessoasTipoSelect.push({
          key: this.state.pessoasSelect[x].key,
          label: this.state.pessoasSelect[x].label,
        })
      } else if ((tipo === 'S') && (this.state.pessoasSelect[x].fornec)) {
        pessoasTipoSelect.push({
          key: this.state.pessoasSelect[x].key,
          label: this.state.pessoasSelect[x].label,
        })
      }
    };

    let planoCtasTipoSelect = [];
    for (var x in this.state.planoCtasSelect) {
      if (tipo === this.state.planoCtasSelect[x].tipo) {
        planoCtasTipoSelect.push({
          key: this.state.planoCtasSelect[x].key,
          label: this.state.planoCtasSelect[x].label,
        })
      }
    };

    this.setState({
      pessoasTipoSelect,
      planoCtasTipoSelect,
    });

  }




  onOK = () => {

    if ((!this.state.registro.tit_data_emissao) || (!moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    const dataAtual = moment().format('YYYY-MM-DD');
    const dataEmiss = moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (dataEmiss > dataAtual) {
      Modal.warning({ title: 'Aviso!', content: 'Data de Emissão maior que data atual' });
      return;
    }
    if (this.state.registro.tit_descricao === '') {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.tit_pessoa) || (this.state.registro.tit_pessoa.key === '0') || (this.state.registro.tit_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe um Cliente/Fornecedor' });
      return;
    }
    if ((!this.state.registro.tit_valor) || (this.state.registro.tit_valor === 0) || (this.state.registro.tit_valor === '0')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Valor' });
      return;
    }
    if ((!this.state.registro.tit_tipo_doc) || (this.state.registro.tit_tipo_doc.key === '0') || (this.state.registro.tit_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento' });
      return;
    }
    if ((!this.state.registro.tit_cond_pagto) || (this.state.registro.tit_cond_pagto.key === '0') || (this.state.registro.tit_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento' });
      return;
    }
    if ((!this.state.registro.tit_plano_conta) || (this.state.registro.tit_plano_conta.key === '0') || (this.state.registro.tit_plano_conta.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Plano de Contas' });
      return;
    }
    if ((!this.state.registro.tit_cta_corrente) || (this.state.registro.tit_cta_corrente.key === '0') || (this.state.registro.tit_cta_corrente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente' });
      return;
    }

    if ((!this.state.listaParcelas) || (this.state.listaParcelas.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Informe as Parcelas' });
      return;
    }

    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.tit_valor)).toFixed(2));
    if (vlrDifParc !== 0) {
      Modal.warning({ title: 'Aviso!', content: 'O Valor Total do Título não Confere com o Valor Total das parcelas' });
      return;
    }


    const registro = {
      tit_idf: this.state.registro.tit_idf,
      tit_controle: this.state.registro.tit_controle,
      tit_numero: this.state.registro.tit_numero ? this.state.registro.tit_numero : '0',
      tit_data_emissao: moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      tit_pessoa: String(this.state.registro.tit_pessoa.key),
      tit_cond_pagto: String(this.state.registro.tit_cond_pagto.key),
      tit_tipo_doc: String(this.state.registro.tit_tipo_doc.key),
      tit_plano_conta: String(this.state.registro.tit_plano_conta.key),
      tit_cta_corrente: String(this.state.registro.tit_cta_corrente.key),
      tit_valor: this.state.registro.tit_valor,
      tit_idf_venda: this.state.registro.tit_idf_venda ? this.state.registro.tit_idf_venda : null,
      tit_idf_contrato: this.state.registro.tit_idf_contrato ? this.state.registro.tit_idf_contrato : null,
      tit_descricao: this.state.registro.tit_descricao,

      listaParcelas: this.state.listaParcelas,
    };

    this.props.onSalvarClick(registro);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangeTipo = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });

    this.montaTipo(event.target.value.key);
  };

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['tit_tipo_doc'] = event.tit_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['tit_cond_pagto'] = event.tit_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCtaCorrente = event => {
    const { registro } = this.state;
    registro['tit_cta_corrente'] = event.tit_cta_corrente;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onDateChange = event => {
    const { registro } = this.state;
    registro['tit_data_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ tit_data_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  montaParcelas = () => {
    let listaNova = [];

    if ((!this.state.registro.tit_tipo_doc) || (this.state.registro.tit_tipo_doc.key === '0') || (this.state.registro.tit_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.tit_cond_pagto) || (this.state.registro.tit_cond_pagto.key === '0') || (this.state.registro.tit_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.tit_valor) > 0) {

      // console.log('montaParcelas w_Parc_AVista: ', this.state.registro)

      // if ((this.state.registro.tit_tipo_doc) && (this.state.registro.tit_cond_pagto) && (this.state.registro.tit_cta_corrente) && (parseFloat(this.state.registro.tit_valor) > 0)) {
      const w_cc = this.state.registro.tit_cta_corrente.key;
      const w_cc_Desc = this.state.registro.tit_cta_corrente.label;
      const w_Qtde_Parc = parseInt(this.state.registro.tit_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.tit_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.tit_valor) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.tit_data_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }


      // console.log('montaParcelas w_Parc_AVista: ', w_Parc_AVista)
      // console.log('montaParcelas w_Sit: ', w_Sit)

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.tit_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.tit_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.tit_valor)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.tit_valor)).toFixed(2));
          vlrDif = vlrDif * (-1);
          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);
          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);
    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.tit_valor)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }



  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    console.log('onEditarParcelaClick', this.state)

    if ((!this.state.registro.tit_tipo_doc) || (this.state.registro.tit_tipo_doc.key === '0') || (this.state.registro.tit_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.tit_cond_pagto) || (this.state.registro.tit_cond_pagto.key === '0') || (this.state.registro.tit_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if ((!this.state.registro.tit_cta_corrente) || (this.state.registro.tit_cta_corrente.key === '0') || (this.state.registro.tit_cta_corrente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Conta Corrente', });
      return;
    }

    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.registro.tit_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };



  renderValor = (tparc_valor) => {
    return (
      <span> {numeral(parseFloat(tparc_valor)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    },
      this.montaTipo(this.state.registro.tit_tipo.key)
    );
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------




  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { tit_idf, tit_controle, tit_numero, tit_tipo, tit_data_emissao,
      tit_pessoa, tit_descricao, tit_valor, tit_cond_pagto, tit_tipo_doc,
      tit_plano_conta, tit_cta_corrente,
    } = this.state.registro;

    const { carregandoForm, modalParcelaVisible, pessoasTipoSelect,
      planoCtasTipoSelect, listaParcelas, vlrTotalParc, vlrDifParc,
      editando, formParcDisabled, modalListaVisible, tipoTela
    } = this.state;

    // console.log('TituloForm.this.state: ', this.state);

    return (
      <Modal
        title={tit_idf ? "Edição do Lançamento Financeiro" : "Inclusão de Lançamento Financeiro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >
        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'pessoas'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={tit_valor}
          condPagto={tit_cond_pagto}
        />

        <div className="card-container" style={{ minHeight: 0 }}>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <Form>
                <Row>
                  <Col xs={24}>
                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Controle</span>
                      <InputForm
                        id="tit_controle"
                        ref="tit_controle"
                        onChange={this.onChange}
                        value={tit_controle}
                        readOnly
                      />
                    </Col>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="tit_numero"
                        ref="tit_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={tit_numero}
                        type="number"
                        decimalScale={0}
                      />
                    </Col>
                    <Col xs={24} sm={5} className="camposEspacoDireita">
                      <span>Tipo *</span>
                      <InputForm
                        type="select"
                        id="tit_tipo"
                        ref="tit_tipo"
                        value={tit_tipo}
                        placeholder="Selecione o Tipo"
                        onChange={this.onChangeTipo}
                        data={OPCOES_COMBO}
                        validator={value => Boolean(value)}
                        disabled={editando || (tipoTela ? true : false)}
                      />
                    </Col>
                    <Col xs={24} sm={7} style={{ marginTop: 4 }} className="camposEspacoDireita">
                      <span>Data Emissão *</span>
                      <DatePicker
                        onChange={this.onDateChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(tit_data_emissao, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Col>

                  <Col xs={12} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Descrição *</span>
                    <InputForm
                      id="tit_descricao"
                      ref="tit_descricao"
                      value={tit_descricao}
                      maxLength={60}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>

                  <Col xs={24} sm={11} style={{ marginTop: -20 }}>
                    <span>Cliente/Fornecedor *</span>
                    <InputForm
                      type="select"
                      id="tit_pessoa"
                      ref="tit_pessoa"
                      value={tit_pessoa}
                      placeholder="Selecione a Pessoa"
                      onChange={this.onChange}
                      data={pessoasTipoSelect}
                      validator={value => Boolean(value)}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: 4, marginLeft: -1 }}>
                    <Tooltip title="Cadastro de Cliente/Fornecedor *" placement="topLeft">
                      <Button
                        type="dashed"
                        icon="plus"
                        htmlType="button"
                        onClick={() => this.onCadPessoaClick()}
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Valor *</span>
                    <InputForm
                      type="number"
                      id="tit_valor"
                      ref="tit_valor"
                      value={tit_valor}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <TipoDocFrame
                      label="Tipo Documento *"
                      id="tit_tipo_doc"
                      value={tit_tipo_doc}
                      width={"100%"}
                      onChange={this.onChangeTipoDoc}
                      descricaoPrimeiroItem="Informe o Tipo de Documento"
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                    <CondPagtoFrame
                      label="Cond Pagto *"
                      id="tit_cond_pagto"
                      value={tit_cond_pagto}
                      width={"100%"}
                      onChange={this.onChangeCondPagto}
                      descricaoPrimeiroItem="Informe a Condição de Pagamento"
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Plano de Contas *</span>
                    <InputForm
                      type="select"
                      id="tit_plano_conta"
                      ref="tit_plano_conta"
                      value={tit_plano_conta}
                      placeholder="Selecione uma Conta"
                      onChange={this.onChange}
                      data={planoCtasTipoSelect}
                      validator={value => Boolean(value)}
                      showSearch
                      disabled={(tipoTela ? true : false)}
                    />
                  </Col>
                  <Col xs={24} sm={10} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <CtaCorrenteFrame
                      label="Conta Corrente *"
                      id="tit_cta_corrente"
                      value={tit_cta_corrente}
                      width={"100%"}
                      onChange={this.onChangeCtaCorrente}
                    />
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: -21 }}>
                    <Tooltip title="Calcular Parcelas">
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={this.montaParcelas}
                        icon="calculator"
                        className="btn-primary"
                        style={{ marginTop: 25 }}
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: -21 }}>
                    <Tooltip title="Editar Parcelas">
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={this.onEditarParcelaClick}
                        icon="edit"
                        className="btn-primary"
                        style={{ marginTop: 25 }}
                      />
                    </Tooltip>
                  </Col>

                </Row>
              </Form>
            </TabPane>

            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 271 }}>
                {vlrDifParc === 0 ? null : (
                  <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                    <Col xs={24}>
                      <Col xs={24} sm={6}>
                        <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                        <span>{this.renderValor(tit_valor)}</span>
                      </Col>
                      <Col xs={24} sm={6}>
                        <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                        <span>{this.renderValor(vlrTotalParc)}</span>
                      </Col>
                      <Col xs={24} sm={6}>
                        <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                        <span>{this.renderValor(vlrDifParc)}</span>
                      </Col>
                    </Col>
                  </Row>
                )}
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaParcelas}
                  pagination={false}
                  rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                >
                  <Column
                    key="tparc_parcela"
                    dataIndex="tparc_parcela"
                    title="Parcela"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="tparc_data_parcela"
                    dataIndex="tparc_data_parcela"
                    title="Data Venc"
                    width={80}
                    align="center"
                    className="listaCadastro"
                    render={this.renderData}
                  />
                  <Column
                    key="tparc_valor"
                    dataIndex="tparc_valor"
                    title="Valor Parc"
                    render={this.renderValor}
                    width={80}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="situacao_parcela"
                    dataIndex="situacao_parcela"
                    title="Situação"
                    width={80}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="td_descricao"
                    dataIndex="td_descricao"
                    title="Tipo Documento"
                    width={300}
                    align="left"
                    className="listaCadastro"
                  />
                </Table>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TituloForm.js